import BigNumber from 'bignumber.js';

BigNumber.config({
  EXPONENTIAL_AT: [-100, 100],
});

const formatAmountWithSpace = (input: BigNumber): string => {
  const decimalPlaces: number = input.dp() ?? 0;

  return input.toFormat(decimalPlaces, {
    groupSeparator: ' ',
    groupSize: 3,
    decimalSeparator: '.',
  });
};

export const formatAmountWithCurrencyToString = (
  input?: number | string,
  currency?: string,
  emptyAmount?: string
): string => {
  if (input === null || input === undefined || input === '') {
    return emptyAmount ?? '';
  }
  try {
    const bn = new BigNumber(input.toString());
    return formatAmountWithSpace(bn) + (currency ? ` ${currency}` : '');
  } catch (error) {
    return emptyAmount ?? '';
  }
};

export const formatAmount = (input?: number | string | null, emptyAmount?: any): JSX.Element => {
  if (input === null || input === undefined || input === '') {
    return emptyAmount ?? '';
  }
  try {
    const bn = new BigNumber(input.toString());
    return <span style={{ whiteSpace: 'nowrap' }}>{formatAmountWithSpace(bn)}</span>;
  } catch (error) {
    return emptyAmount ?? '';
  }
};

export const formatFiatAmountWithCurrency = (
  input?: number | string | null,
  currency?: string,
  emptyAmount?: any
): JSX.Element => {
  const formattedAmount = formatAmount(input, emptyAmount);

  return (
    <span>
      {formattedAmount}
      {currency && <span>{` ${currency}`}</span>}
    </span>
  );
};

export const formatBlockchainAmountWithCurrency = (
  input?: number | string,
  currency?: string,
  emptyAmount?: any
): JSX.Element => {
  const formattedAmount = formatAmount(input, emptyAmount);

  return (
    <span>
      {formattedAmount}
      {currency && <span>{` ${currency}`}</span>}
    </span>
  );
};

export const formatShort = (str: string) => {
  if (str.length <= 8) {
    return str;
  }
  const first = str.slice(0, 4);
  const last = str.slice(-4);
  return `${first}...${last}`;
};
